<template>
  <div class="container">

    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goto('/cleanex/guide')"></span></div>

        <div class="daojia-navbar-left" v-show="$route.query.back" @click="$router.go(-1)"><span class="icon-chevron-left"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>



    <div class="core">
        <div class="title">中度、重度脏的额外收费</div>
        <div class="formula">
          <div class="subtitle">
            基础费用适用于正常脏度的环境，如您房子/家电较脏，需收取额外的费用，下方参考图片可点击查看大图
          </div>
          <br>
        </div>

        <div class="main pricing-zone dirty clearfix" >
          <div class="cell last">
            <div class="type ">中度脏</div>
            <div class="description-dirty">额外 + $50</div>
          </div>
          <div class="cell last">
            <div class="type">重度脏</div>
            <div class="description-dirty">额外 + $100</div>
          </div>
        </div>
    </div>
    <div class="reviews" v-for="pics in galleryPics" >
        <div class="date">{{pics.date}}</div>
        <vue-picture-swipe :options="galleryOptions" :items="pics.info"></vue-picture-swipe>
    </div>

    <div class="btn-box">
      <div class="btn-container">
              <div class="btn active" @click="$router.go(-1)" >返回</div>
      </div>
    </div>

    <transition name="fade">
        <div id="loadingToast" v-show="isSending && galleryPics.length==0 ">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在加载相册</p>
            </div>
        </div>
    </transition>

  </div>

</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import anime from 'animejs';

export default {
  name: 'review',
  data () {
    return {
      isSending:false,
      galleryPics:[
    {
        "date": "灶台",
        "info": [
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/a1.jpg?x-oss-process=image/resize,w_1200/sharpen,100/quality,Q_90",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/a1.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/a2.jpg?x-oss-process=image/resize,w_1200/sharpen,100/quality,Q_90",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/a2.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/a3.jpg?x-oss-process=image/resize,w_1200/sharpen,100/quality,Q_90",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/a3.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },

        ]
    },
    {
        "date": "油烟机",
        "info": [
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/b1.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/b1.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/b2.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/b2.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/b3.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/b3.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },

        ]
    },
    {
        "date": "烤箱",
        "info": [
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/c1.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/c1.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/c2.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/c2.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/c3.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/c3.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },

        ]
    },
    {
        "date": "卫生间玻璃",
        "info": [
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/d1.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/d1.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/d2.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/d2.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },
            {
                "type": "1",
                "creation_month": "2022-09",
                "src": "https://asset.daojia.com.au/daojia/dirty/d3.jpg",
                "thumbnail": "https://asset.daojia.com.au/daojia/dirty/d3.jpg?x-oss-process=image/resize,w_500/crop,w_250,h_250,g_nw/sharpen,100/quality,Q_80",
                "w": 0,
                "h": 0
            },

        ]
    }
],
      reviewStop:false,
      currentDate:'',
      galleryOptions:{
        bgOpacity: 0.8,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: true,
        shareEl: false,
        arrowEl: false,
        tapToClose: true,
        showAnimationDuration :0,
        hideAnimationDuration :0
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    ifShowDate(mass){
        if(this.serviceFilter=='all'){
            return true
        }
        else if(mass[this.serviceFilter]>0){
            return true
        }
        else{
            return false
        }
    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 300,
            easing = arg.easing || 'easeInSine',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToTop(){
        this.scroll({
            to: '.toppanel'
        });
    },

    onWaypoint ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        //this.getPricing();
      }

    }
  }
}

</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
    padding-top:60px;
}

.core{
  padding:0 18px;
  margin-top:20px;
}
.cell{
    float:left;
    width:50%;
    border-bottom:1px solid #eee;
    box-sizing: border-box;
    height: 100px;
    text-align: center;
    cursor: pointer;
}
.cell-tall{
    height: 120px;
}
.cell:active{
    background: #eee;
}
.cell:nth-child(odd) {
    border-right:1px solid #eee;
}
.cell.last, .item.last{
    border-bottom:0;
}
.cell img{
    width:60px;
}

.description-dirty{
  color:#fb6882;
  font-size:1.2em;
  margin-top:5px;
}

.type{
    font-size:1.1em;
    font-weight:bold;
    color:#5A5C68;
    margin-top:25px;
  line-height:1.3;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}


.reviews  /deep/{
    .date{
        font-size:1.3em;
        font-weight:bold;
        margin:20px 8px 8px 8px;
        color:#555;
    }

    .my-gallery{
        display: flex;
        justify-content:space-between;
        padding:0 10px;
        figure{
            width:32%;
            img{
                width:100%;
                border-radius: 2px;
            }
        }

      .gallery-thumbnail {
        display: inline;
        margin:0!important;
      }
    }
}

.filter{
    padding:12px 12px 15px 12px;
    display: flex;
    justify-content:space-around;
    .pill{
        display:inline-block;
        font-size:0.8em;
        background:#f6f6f6;
        padding:4px 12px;
        border-radius:20px;
        &.active{
            color:$color-orange;
            background:#fff0ee;
            font-weight:bold;
        }
    }
}


.title{
    font-size:16pt;
    padding:0;
}

.vehicle-img img{
    max-width:100%;
}

.pricing-zone{
    border: 1px solid #eee;
    background:#fff;
    border-radius: 8px;
    -webkit-box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
    box-shadow: 0 10px 10px -10px rgba(200, 200, 200, 0.8);
    margin-top:20px;
    margin-bottom: 20px;
    &.dirty{
      margin-top:0px;
    }
}

.bg-title-sub{
  font-size:1.1em;
  font-weight:bold;
  color:#fff;
  margin-left:22px;
}

.subtitle{
  text-align:center;
  font-size:0.9em;
  color:#888;
}

</style>



// WEBPACK FOOTER //
// src/pages/other/clean-comparison.vue